import { useEffect, useState } from 'react';

function preference(): boolean {
  try {
    const value = localStorage.getItem('support-appearance');
    if (value === 'light' || value === 'dark') return value === 'dark';
  } catch {
    /* Storage may be blocked in an embedded context. */
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}
// Set the initial theme before React mounts controls with color transitions.
export function initializeAppearance(): void {
  const dark = preference();
  document.documentElement.classList.toggle('dark', dark);
  document.documentElement.classList.toggle('light', !dark);
}

export function useAppearance() {
  const [dark, setDark] = useState(preference);
  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark);
    document.documentElement.classList.toggle('light', !dark);
  }, [dark]);
  useEffect(() => {
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const sync = () => setDark(preference());
    media.addEventListener('change', sync);
    window.addEventListener('storage', sync);
    return () => {
      media.removeEventListener('change', sync);
      window.removeEventListener('storage', sync);
    };
  }, []);
  return {
    dark,
    toggle: () => {
      const next = !dark;
      try {
        localStorage.setItem('support-appearance', next ? 'dark' : 'light');
      } catch {
        /* Session-only preference when storage is unavailable. */
      }
      setDark(next);
    },
  };
}
